/* eslint-disable @typescript-eslint/no-explicit-any */
export function replaceNonEncodedSpace(str: string) {
  const regex = '&nbsp;';
  return str.replaceAll(regex, ' ');
}

export function stripHtmlTagsFromString(str: string): string {
  const regex = /<\/?[^>]+(>|$)/g;
  return str.replaceAll(regex, '');
}

export function titleCase(str: any): string {
  if (!str || str == undefined) {
    return '';
  }
  const splitStr: string[] = str.toLowerCase().split(' ');
  for (let i = 0; i < splitStr.length; i++) {
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr.join(' ');
}

export function capitalizeFirstLetter(str?: string): string {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function stringToCamelCase(str: string): string {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, '');
}

export function addSpacesToCamelCase(str: string): string {
  return str.replace(/([A-Z])/g, ' $1');
}

export function turnUnderscoresToSpaces(str: string): string {
  return str.replace(/_/g, ' ');
}

export function turnSpacesToDashes(str: string): string {
  return str.replace(/ /g, '-');
}

export function turnSpacesToUnderScores(str: string): string {
  return str.replace(/ /g, '_');
}

export function comparePossiblyUndefined(a: string | undefined, b: string | undefined): number {
  if (!a && !b) return 0;
  else if (!a) return 1;
  else if (!b) return -1;

  return a.toString().localeCompare(b);
}
